module.exports = new __parcel__URL__("soulstealer.6885a998.png").toString();